export default {
	precision(money) {
		var precision = localStorage.getItem('precision');
		return this.tofixed(money, precision);
	},
	precision_basic(money) {
		// TODO:: 写死保留3位小数
		var precision = localStorage.getItem('precision_basic');
		return this.tofixed(money, 3);
	},
	currency() {
		return localStorage.getItem('currency');
	},
	currency_symbol_basic(money) {
		return localStorage.getItem('currency_symbol_basic');
	},
	tofixed(number, precision) {
		var str = number + "";
		var len = str.length;

		var last = str.substring(len - 1, len);
		var afterPoint = str.substring(str.indexOf(".") + 1, len);
		if (afterPoint.length > precision) {
			var last = afterPoint.substring(precision, parseInt(precision) + 1);
		}

		if (last == "5" && afterPoint.length > precision) {
			last = "6";
			str = str.substring(0, len - 1) + last;
			return (str - 0).toFixed(precision);
		} else {
			return (number / 1).toFixed(precision);
		}
	}
}
